export default "__VITE_ASSET__fa9920c3__"